import { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';

/**
 * Hook personnalisé pour vérifier les permissions de l'utilisateur connecté
 */
export const useIsAdmin = (): { 
  isAdmin: boolean; 
  canDeletePlanches: boolean;
  canAddRituels: boolean;
  canDeleteRituels: boolean;
  loading: boolean 
} => {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [canDeletePlanches, setCanDeletePlanches] = useState<boolean>(false);
  const [canAddRituels, setCanAddRituels] = useState<boolean>(false);
  const [canDeleteRituels, setCanDeleteRituels] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const checkPermissions = async () => {
      const auth = getAuth();
     
      const unsubscribe = onAuthStateChanged(auth, async (user) => {
        if (user) {
          try {
            const db = getFirestore();
           
            // Récupérer les informations du membre connecté
            const membresQuery = query(
              collection(db, 'Membres'),
              where('mail', '==', user.email)
            );
           
            const membresSnapshot = await getDocs(membresQuery);
           
            if (!membresSnapshot.empty) {
              const membreData = membresSnapshot.docs[0].data();
              const userIsAdmin = membreData.administrateur === 'oui';
              
              // Définir les permissions selon les règles de l'application
              setIsAdmin(userIsAdmin);
              setCanDeletePlanches(userIsAdmin);
              setCanAddRituels(userIsAdmin);
              setCanDeleteRituels(userIsAdmin);
            } else {
              console.error('Utilisateur non trouvé dans la collection Membres');
              setIsAdmin(false);
              setCanDeletePlanches(false);
              setCanAddRituels(false);
              setCanDeleteRituels(false);
            }
          } catch (error) {
            console.error('Erreur lors de la vérification des droits:', error);
            setIsAdmin(false);
            setCanDeletePlanches(false);
            setCanAddRituels(false);
            setCanDeleteRituels(false);
          } finally {
            setLoading(false);
          }
        } else {
          setIsAdmin(false);
          setCanDeletePlanches(false);
          setCanAddRituels(false);
          setCanDeleteRituels(false);
          setLoading(false);
        }
      });
      return () => unsubscribe();
    };
    checkPermissions();
  }, []);

  return { 
    isAdmin, 
    canDeletePlanches, 
    canAddRituels, 
    canDeleteRituels, 
    loading 
  };
};

export default useIsAdmin;